import * as dm from 'generated/api/dm.api';

type AddObjectBooking = dm.paths['/open-api/applications-client/addObjectBooking'];
export type AddObjectBookingParams = AddObjectBooking['post']['parameters']['body']['dto'];
export type ObjectBookingRes = AddObjectBooking['post']['responses']['200']['schema'];

type GetRulesGuid = dm.paths['/open-api/settings/getByKeys/{keysList}'];
export type Rules = GetRulesGuid['get']['responses']['200']['schema'];
